import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "../../../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

import SubscriptionPlansSection from "./Widget/PlanCardsSection";
import InvoiceSection from "./Widget/InvoiceSection";
import PaymentSection from "./Widget/ReceivingPayment";

export default function PaymentPage() {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);

  // Fatura bilgileri değiştiğinde
  const handleInvoiceDataChange = (data) => {
    setInvoiceData(data);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login_corporate");
        return;
      }

      const stored = localStorage.getItem("companyData");
      if (!stored) {
        navigate("/login_corporate");
        return;
      }

      const parsed = JSON.parse(stored);
      const taxNumber = parsed?.taxNumber;

      if (!taxNumber) {
        navigate("/login_corporate");
        return;
      }

      try {
        const companiesRef = collection(db, "companies");
        const q = query(
          companiesRef,
          where("taxInfo.taxNumber", "==", Number(taxNumber))
        );

        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          navigate("/login_corporate");
          return;
        }

        const docSnap = snapshot.docs[0];
        const data = docSnap.data();

        setCompany({
          id: docSnap.id,
          company_id: data.company_id || "",
          company_name: data.company_name || data.company_id || "",
          taxInfo: data.taxInfo || {},
          email: data.email || "",
          phone: data.phone || "",
          location: data.location || "",
        });
      } catch (error) {
        console.error("Şirket bilgisi yüklenemedi:", error);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p>Yükleniyor...</p>
      </div>
    );
  }

  if (!company) {
    return (
      <div style={styles.errorContainer}>
        <p>Şirket bilgisi bulunamadı.</p>
        <button onClick={() => navigate("/login_corporate")}>
          Giriş Sayfasına Dön
        </button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Abonelik Yükseltme</h1>
        <p style={styles.subtitle}>Planınızı seçin ve ödeme yapın</p>
      </div>

      <div style={styles.content}>
        {/* Abonelik Planları */}
        <div style={styles.section}>
          <SubscriptionPlansSection
            companyId={company.id}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
          />
        </div>

        {/* Fatura Bilgileri */}
        <div style={styles.section}>
          <InvoiceSection 
            company={company}
            onInvoiceDataChange={handleInvoiceDataChange}
          />
        </div>

        {/* Ödeme */}
        <div style={styles.section}>
          <PaymentSection 
            selectedPlan={selectedPlan}
            invoiceData={invoiceData}
            company={company}
          />

        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#F9FAFB",
    padding: "20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    maxWidth: "800px",
    margin: "0 auto 30px",
    textAlign: "center",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#111827",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "16px",
    color: "#6B7280",
    margin: 0,
  },
  content: {
    maxWidth: "800px",
    margin: "0 auto",
  },
  section: {
    marginBottom: "30px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #4F46E5",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  errorContainer: {
    textAlign: "center",
    padding: "40px",
  },
};

/* Spinner animation */
const styleSheet = document.createElement("style");
styleSheet.textContent = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
document.head.appendChild(styleSheet);